export function getSharedCookieDomain(
	currentHostname: string | undefined,
	sharedUrl: string | undefined,
): string | undefined {
	if (!currentHostname || !sharedUrl) {
		return;
	}

	const sharedHostname = new URL(sharedUrl).hostname;
	if (currentHostname === sharedHostname || currentHostname.endsWith(`.${sharedHostname}`)) {
		return sharedHostname;
	}
}
